import { Head } from "@inertiajs/react"

import { StageBoard } from "@/components/products/work_orders/stage-board"
import type {
  WorkOrderFilterOptions,
  WorkOrderFilters,
  WorkOrderRow,
} from "@/components/products/work_orders/types"
import { WorkOrderFilterBar } from "@/components/products/work_orders/work-order-filters"
import { WorkOrderHeader } from "@/components/products/work_orders/work-order-header"
import { useOrgRoutes } from "@/hooks/use-org-routes"
import AppLayout from "@/layouts/app-layout"
import type { BreadcrumbItem } from "@/types"

interface Props {
  stages: { key: string; label: string }[]
  work_orders: WorkOrderRow[]
  filters: WorkOrderFilters
  filter_options: WorkOrderFilterOptions
  counts: { open: number; closed: number; pending_review: number }
  can_edit: boolean
}

export default function WorkOrdersBoard({
  stages,
  work_orders,
  filters,
  filter_options,
  counts,
}: Props) {
  const routes = useOrgRoutes()

  const breadcrumbs: BreadcrumbItem[] = [
    { title: "Dashboard", href: routes.dashboardPath() },
    { title: "Work Orders", href: routes.workOrdersPath() },
    { title: "Board", href: routes.workOrdersBoardPath() },
  ]

  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title="Work Orders — Board" />

      <div className="space-y-5 p-6">
        <WorkOrderHeader
          tablePath={routes.workOrdersPath()}
          boardPath={routes.workOrdersBoardPath()}
          view="board"
          pendingReview={counts.pending_review}
          inboxPath={routes.inboxPath()}
        />

        <p className="text-muted-foreground text-sm">
          Bad orders only — the other work-order types have two or three states
          and read better as a table.
        </p>

        <WorkOrderFilterBar
          filters={filters}
          options={filter_options}
          path={routes.workOrdersBoardPath()}
          counts={counts}
        />

        <StageBoard stages={stages} workOrders={work_orders} />
      </div>
    </AppLayout>
  )
}
